import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { IHolidaySlice } from "./types";

const selectSelf = (state: RootState) => state;
const selectHoliday = createSelector(selectSelf, (state) => state.holidays);

export const selectHolidayList = createSelector(
  selectHoliday,
  (slice: IHolidaySlice) => slice?.holidayList || []
);

export const selectIsHolidayLoading = createSelector(
  selectHoliday,
  (slice: IHolidaySlice) => slice?.isLoading || false
);
